import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly keys = ['accessToken', 'token'];

  getToken(): string | null {
    for (const k of this.keys) {
      const v =
        typeof localStorage !== 'undefined' ? localStorage.getItem(k) : null;
      if (v) return v;
    }
    return null;
  }

  setToken(token: string) {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('accessToken', token);
    }
  }

  clear() {
    if (typeof localStorage !== 'undefined') {
      for (const k of this.keys) localStorage.removeItem(k);
    }
  }
}
